module.exports = __webpack_public_path__ + "amcharts/images/dragIconRectBigBlackH.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRectBigBlackH.png
// module id = 234
// module chunks = 0